import React from "react";
import { useMsal } from "@azure/msal-react";
import Button from "react-bootstrap/Button";

import { loginRequest } from "../auth/authConfig";

export const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    }
    return (
        <Button variant="secondary" onClick={()=>handleLogin("redirect")}>Sign in using Redirect</Button>
   )
}